export default "__VITE_ASSET__BsWZjxsG__"